import ConverstaionList from "./components/ConverstaionList";
import BottomNav from '../../components/BottomNav'
import { HomeScreenType } from "../../helpers/Enums";
import DesktopNav from "../../components/DesktopNav";

export function ConverstaionContainer() {
   return (
      <div>
         <ConverstaionList />
         <DesktopNav screenType={HomeScreenType.CONVERSTAION} />
         <BottomNav screenType={HomeScreenType.CONVERSTAION} />
      </div>
   )
}